// extracted by mini-css-extract-plugin
module.exports = {"hr":"HR_hr__KdVl9"};
module.exports.__checksum = "754a23d341d9"
